const CDN_BASE = process.env.REACT_APP_CDN_BASE_URL;

/**
 * Returns a thumbnail URL for the given blob URL.
 * When REACT_APP_CDN_BASE_URL is set, routes through CDN and appends a width
 * resize parameter (requires Azure CDN / Front Door image optimization enabled).
 * Until CDN is configured this is a no-op and returns the original blob URL.
 */
export function toThumbnailUrl(blobUrl: string, width = 200): string {
    if (!CDN_BASE) return blobUrl;
    const cdnUrl = blobUrl.replace(/^https:\/\/[^/]+/, CDN_BASE);
    return `${cdnUrl}?width=${width}`;
}
